const styles = theme => ({
  value: theme.mixins.gutters({
    margin: 0,
    fontWeight: 200
  }),
  wow:{
    color:'red',
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/tdnext/line/styles.js